<template>
  <div class="value-proposition">
    <div class="value-body">
      <h2 class="title">方案价值</h2>
      <div class="value-items">
        <div class="value-item" v-for="(item, index) in values" :key="index">
          <img :src="item.icon" :alt="item.title" class="value-icon" />
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ValueProposition',
  data() {
    return {
      currentSource: '',
      values: [
        {
          icon: 'https://hr2.chnsoft.com.cn/img/efficiency.png',
          title: '提升执法效率',
          description: '华软体系支撑的无人装备能够快速覆盖大面积区域，执行探测、监控和勘查任务，显著提高响应速度和工作效率，确保及时处理各类突发事件。',
        },
        {
          icon: 'https://hr2.chnsoft.com.cn/img/decision.png',
          title: '增强决策支持',
          description: '通过实时数据传输与智能分析平台，无人机提供全面的实时高精度数据支持，帮助指挥中心做出更明智的决策。',
        },
        {
          icon: 'https://hr2.chnsoft.com.cn/img/safety.png',
          title: '保障人员安全',
          description: '无人机代替警察进入危险或难以到达的区域执行任务，减少人员暴露于风险中的机会，确保执法人员的安全。',
        },
        {
          icon: 'https://hr2.chnsoft.com.cn/img/data.png',
          title: '数据治理重构',
          description: '打通视频监控、物联网感知和警务系统数据壁垒，构建智能化数据整合分析平台，为公安系统的精确治理管理提供科学支持。',
        },
        {
          icon: 'https://hr2.chnsoft.com.cn/img/intelligence.png',
          title: '促进智慧警务',
          description: '集成先进的AI技术和数据分析工具，无人机助力实现智能化、精细化管理，推动公安系统的精确警务管理，提升整体治安水平。',
        },
      ],
    };
  },
  watch: {
    // 监听 URL 的变化
    '$route.fullPath': {
      immediate: true,
      handler() {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get('source');

        this.currentSource = source;
        this.updateList();

      },
    },
  },
  methods: {
    updateList() {

      switch (this.currentSource) {
        case 'industry_safety_1':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高效响应.png',
              title: '提升执法效率',
              description: '华软体系支撑的无人装备能够快速覆盖大面积区域，执行探测、监控和勘查任务，显著提高响应速度和工作效率，确保及时处理各类突发事件。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/增强决策支持.png',
              title: '增强决策支持',
              description: '通过实时数据传输与智能分析平台，无人机提供全面的实时高精度数据支持，帮助指挥中心做出更明智的决策。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '保障人员安全',
              description: '无人机代替警察进入危险或难以到达的区域执行任务，减少人员暴露于风险中的机会，确保执法人员的安全。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/数据治理重构.png',
              title: '数据治理重构',
              description: '打通视频监控、物联网感知和警务系统数据壁垒，构建智能化数据整合分析平台，为公安系统的精确治理管理提供科学支持。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/技术领航.png',
              title: '促进智慧警务',
              description: '集成先进的AI技术和数据分析工具，无人机助力实现智能化、精细化管理，推动公安系统的精确警务管理，提升整体治安水平。',
            },
          ]
          break;
        case 'industry_safety_2':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/极速响应.png',
              title: '极速响应',
              description: '无人机分钟级抵临灾害现场，高空侦察+位置标定，抢占救援黄金时间。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/无人强攻.png',
              title: '无人强攻',
              description: '消防车/机器人替代人工抵近高危区，实现侦察、指挥、灭火无人化闭环。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/技术领航.png',
              title: '全域掌控',
              description: '多机协同实时回传高清画面，快速构建三维灾情模型，辅助精准决策。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '极限突破',
              description: '机器人适应毒气、辐射等极端环境，拓展人力不可达的救援边界。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/成本优化.png',
              title: '降险增效',
              description: '减少救援人员伤亡风险，智能调度资源大幅提升应急处置效率。',
            },
          ]
          break;
        case 'industry_power_1':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高效巡检精准识别.png',
              title: '高效巡检 精准识别',
              description: '采用高精度双光云台、激光雷达及边缘计算设备，实现杆塔金具缺陷识别，支持厘米级定位自主航线规划，大幅提升巡检效率。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/智能监测决策支持.png',
              title: '智能监测 决策支持',
              description: '持通过AI智能识别，自动识别绝缘子破损、金具腐蚀等典型缺陷及通道树障隐患等智能监测。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/实时管理闭环控制.png',
              title: '实时管理 闭环控制 ',
              description: '建立"任务自动派发-巡检数据实时回传-缺陷分级预警-报告自动输出"管理体系，自动生成标准化报告。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/成本优化.png',
              title: '减少成本 提升效益',
              description: '自动化运维减少人力投入，智能调度优化资源分配，推动电力运维数字化转型。',
            },

          ]
          break;
        case 'industry_power_2':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/无人强攻.png',
              title: '无人值守 自主巡检',
              description: '构建集群式无人机自主巡检体系，在变电（换流）站复杂电磁干扰环境中，实现设备无人值守状态下“精细化、全方位、无死角”巡检。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/智能数据整合.png',
              title: '智能分析 故障诊断 ',
              description: '依托国产AI多模态大模型多源数据智能识别能力，快速分析机巡数据，精准定位设备故障，提前预警潜在隐患，缩短故障排查时间。 ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/极速响应.png',
              title: '应急响应 决策支持	',
              description: '当突发设备故障或遇自然灾害时，系统可迅速放飞无人机，实时回传现场画面，辅助进行应急决策，增强变电（换流）站应急处置能力。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/数据运营闭环管理.png',
              title: '数据运营 闭环管理',
              description: '巡检数据经整合分析，形成全生命周期数据库，为运维策略优化、设备升级提供数据支撑，实现变电（换流）站智能化、精细化管理。',
            },

          ]
          break;
        case 'industry_power_3':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高效响应.png',
              title: '精准覆盖 效率跃升',
              description: '采用高精度双光云台、激光雷达及边缘计算设备，实现配电柜、变压器等设备的缺陷识别，支持高精度自主航线规划，有效提升巡检效率和质量。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '多维感知 主动防御',
              description: '借助AI智能识别技术，自动识别绝缘子破损、金具腐蚀等典型缺陷，同时对配电设备的运行状态和环境进行实时监测，为运维决策提供科学依据。 ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/极速响应.png',
              title: '闭环管控 快速响应',
              description: '建立“任务自动派发-巡检数据实时回传-缺陷分级预警-报告自动生成”管理体系，实现巡检流程的标准化、规范化，提高运维管理效率。 ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精益管理可靠供电.png',
              title: '精益管理 可靠供电',
              description: '自动化运维减少人力投入，智能调度优化资源分配，降低运维成本，提升配电运维的效率和效益，推动电力运维数字化转型。 ',
            },
          ]
          break;
        case 'industry_power_4':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '安全强化',
              description: '空地立体巡检+火灾智能处置，实现对直流设备的全方位巡检及立体化火情处置，保障电网安全。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '效率革新',
              description: '有效提升巡检速度和覆盖率，无人应急处置装备迅速启动，缩短火灾处理时间，减少停电风险。 ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/成本优化.png',
              title: '成本优化',
              description: '大幅减少人工巡检需求，降低人力成本和安全装备建设投入，释放资源聚焦核心设备健康管理。  ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/深度适配.png',
              title: '深度适配',
              description: '系统依托直流数字化平台规范开发，兼容DCOS数字化系统平台，保障现有系统投资价值延续。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/技术领航.png',
              title: '技术领航',
              description: '构建直流体系"智能预判-自动处置"闭环体系，打造直流智慧运维新范式，支撑新型电力系统建设。',
            },
          ]
          break;
        case 'industry_energy_1':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准检测提升效率.png',
              title: '精准检测 提升效率',
              description: '无人机快速覆盖大面积光伏阵列，自动识别电池板裂纹、污垢及阴影遮挡，提高检测效率与准确性，确保电站高效运行。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/实时监控预警维护.png',
              title: '实时监控 预警维护',
              description: '采用AI智能分析无人机采集数据，实现光伏组件健康状态的实时监控和早期预警，及时安排维护，减少故障损失，保障系统稳定。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/成本优化资源节约.png',
              title: '成本优化 资源节约',
              description: '自动化巡检减少人力投入和时间成本，优化资源配置，降低长期运维成本，提升经济效益，助力企业可持续发展。 ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '安全保障 智能响应',
              description: '无人机执行高空或复杂地形巡检任务，降低作业风险，同时提供智能应急响应方案，增强安全性，保护人员与设备安全。',
            },
          ]
          break;
        case 'industry_energy_2':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全作业升级.png',
              title: '安全作业升级',
              description: '无人机替代人工进入高空、海上等危险场景，规避攀爬百米风机、穿越复杂地形等高风险操作，极大降低人员坠落与极端环境作业风险。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高效响应.png',
              title: '场景高效覆盖',
              description: '灵活应对山地、荒漠、海上等多变环境，快速完成单台风机的叶片、塔筒、机舱等全方位检测，显著提升大范围风电场的整体巡检效率。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/智能精准诊断.png',
              title: '智能精准诊断',
              description: 'AI算法融合多源数据，自动识别叶片腐蚀、螺栓松动、轴承过热等隐蔽缺陷，生成设备健康度评估报告，为精准维修提供决策依据。 ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '绿色效益提升',
              description: '通过隐患早发现、故障快处理，减少非计划停机损失，最大化风电场发电效能，助力企业实现低碳可持续发展目标。',
            },
          ]
          break;
        case 'industry_energy_3':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '安全升级 降低风险',
              description: '通过无人机执行高风险区域的巡检任务，减少人员进入潜在危险环境的风险，如陡峭的大坝斜坡或狭窄的输水隧道，从而大幅提升作业安全性。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '优化维护 提升寿命',
              description: '利用AI技术分析无人机收集的数据，提前识别设备磨损、结构损伤等问题，帮助制定更加科学合理的预防性维护计划，延长设施使用寿命。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准检测保障安全.png',
              title: '实时监控 快速响应',
              description: '无人机能够提供即时数据反馈，支持对突发状况的快速反应和处理，比如紧急漏水或地质灾害后的即时评估，确保及时采取措施防止事态恶化。 ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/灵活操作广泛覆盖.png',
              title: '灵活操作 广泛覆盖',
              description: '无人机不受地形限制，能够在短时间内到达任何需要检查的位置，极大地提高了巡检工作的灵活性和覆盖面，特别适用于难以接近的大坝和输水系统。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/技术领航.png',
              title: '数字管理 智慧升级',
              description: '集成无人机巡检数据到现有的数字管理系统中，实现数据对接和智能分析，助力企业构建更加智能化、自动化的管理体系，推动行业向智慧化方向发展。',
            },
          ]
          break;
        case 'industry_energy_4':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全保障.png',
              title: '安全保障',
              description: '利用智能无人机及无人车执行危险任务，减少人员在高风险环境的暴露，确保作业安全。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '效率提升',
              description: '无人机快速巡检大面积区域，无人车迅速响应紧急情况，二者结合缩短问题发现和处理时间。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/成本控制.png',
              title: '成本控制',
              description: '自动化操作减少人力需求，优化资源配置，有效降低长期运维成本，提高经济效益。 ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准分析.png',
              title: '精准分析',
              description: '采用智能识别技术深度分析数据，实现早期预警和故障点精确定位，提升维护工作的针对性。',
            },

          ]
          break;
        case 'industry_energy_5':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高效巡检精准识别.png',
              title: '高效巡检 精准识别',
              description: '利用高精度双光云台、激光雷达及边缘计算设备，检测管道泄漏、腐蚀等问题，支持高精度自主航线规划，提升巡检效率和质量。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/智能监测决策支持.png',
              title: '智能监测 决策支持',
              description: 'AI智能识别技术，自动识别设备异常、火灾隐患等问题，实时监测运行状态和环境，为运维决策提供科学依据。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/极速响应.png',
              title: '实时管理 闭环控制',
              description: '建立“任务自动派发-巡检数据实时回传-缺陷分级预警-报告自动生成”管理体系，实现巡检流程标准化、规范化，提高运维管理效率。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精益管理可靠供电.png',
              title: '减少成本 提升效益',
              description: '自动化运维减少人力投入，智能调度优化资源分配，降低运维成本，提升运维效率和效益，推动天然气运维数字化转型。',
            },

          ]
          break;

        case 'industry_other_1':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高效巡检提升效率.png',
              title: '高效巡检 提升效率',
              description: '无人机快速覆盖大面积区域，实时采集高清影像与数据，效率提升数倍，及时发现设备故障或地质隐患。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准检测保障安全.png',
              title: '精准检测 保障安全',
              description: '通过配备多模组相机、X光探伤等负载，智能识别轨道、接触网等设施缺陷，有效降低安全风险，保障设施完好。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/智能分析辅助决策.png',
              title: '智能分析 辅助决策',
              description: '结合AI智能分析技术，实时处理巡检数据，自动识别异常情况，如非法入侵、异物侵限等，提供科学决策依据。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/成本优化.png',
              title: '降低成本 提高效益',
              description: '大幅减少人力投入，避免资源消耗，降低运维成本，提高巡检工作的经济性和可持续性，有效增强经济效益。 ',
            },


          ]
          break;
        case 'industry_other_2':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准检测保障安全.png',
              title: '全域覆盖，精准监控',
              description: '无人机可快速覆盖人车难至的复杂地形（如高山、密林、礁石区），搭载红外热成像、激光雷达等设备，实现缺陷识别与非法目标识别。  ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/极速响应.png',
              title: '智能决策，快速响应',
              description: '智能算法实时分析巡检数据，自动标记可疑目标（如非法越境、走私船只），并回传至指挥中心，提升应急响应速度。  ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/无人作业安全高效.png',
              title: '无人作业，安全高效',
              description: '规避高危环境（如恶劣海况、雷区、疫区）下的人工作业风险，同时支持远程喊话、取证驱离等非接触式执法。  ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/多维协同综合优化.png',
              title: '多维协同，综合优化',
              description: '单次任务可同步完成设施巡检（边防工事、航标）、环境监测（水质、污染）及安全防控（偷渡、非法捕捞），有效降低综合运维成本。',
            },




          ]
          break;
        case 'industry_other_3':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准检测保障安全.png',
              title: '日常巡检 设备监控',
              description: '无人机高频次巡查露天矿坑、尾矿坝、电力线路及矿卡车辆，实时采集高清影像与数据，及时发现设备故障或地质隐患，确保矿区安全。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/气体检测安全保障.png',
              title: '气体检测 安全保障',
              description: '通过激光甲烷探测器等设备，无人机非接触式监测可燃气体浓度，降低人员暴露风险，保障作业安全，提升矿区环境安全性。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/三维建模资源管理.png',
              title: '三维建模 资源管理',
              description: '高精度三维建模辅助矿山数字化管理，优化采矿规划与资源评估，支持矿区高效运营和可持续发展，提高资源利用效率。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/极速响应.png',
              title: '应急响应 灾害预警',
              description: '无人机快速抵达塌方、火灾等突发事件现场，实时传输画面，提供关键数据支持救援决策，增强矿区应急响应能力。',
            },




          ]
          break;
        case 'industry_other_4':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/极速响应.png',
              title: '效率提升 全面覆盖',
              description: '自动化巡检大幅减少人工干预，快速获取数据，提升工作效率，支持大规模环境监测任务。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '精准分析 决策支持',
              description: '结合多模态大模型，提供高精度的环境监测与分析报告，增强决策依据的科学性和准确性。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/技术领航.png',
              title: '全天作业 环境适应',
              description: '多类型无人装备协同作业，完成多环境全天候、不间断的巡检任务，保障监测工作的连续性。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/灵活操作广泛覆盖.png',
              title: '成本优化 经济高效',
              description: '无人系统应用可有效降低人力和运维成本，实现资源高效利用，减少开支，提高经济效益。',
            },



          ]

          break;
        case 'industry_other_5':

          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '全域覆盖，立体防控',
              description: '集成空中、水面和地面设备，实现全面监控与巡检，确保无死角覆盖，提升港口整体安全性。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '高效应急，精准处置',
              description: '陆空协同应急处置机器人和无人驾驶消防车，提升突发事件处理能力，确保火灾及时有效的应急响应。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/数据驱动智能诊断.png',
              title: '数据驱动，智能诊断',
              description: '利用多模态大模型技术，提供高精度的数据分析与报告，增强决策依据的科学性和准确性。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/全时值守韧性升级.png',
              title: '全时值守，韧性升级',
              description: '多类型无人装备协同作业，保障不间断的巡检与应急任务，确保港口运营的连续性和稳定性。  ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高效响应.png',
              title: '集约增效，成本优化',
              description: '有效降低人力和运维成本，提高资源利用效率，通过自动化设备减少开支，提升经济效益。 ',
            },



          ]
          break;
        case 'industry_other_6':
          this.values = [

            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '高效巡检 安全保障',
              description: '无人机进行空中巡检，快速覆盖大面积区域，实时监控施工现场动态，确保施工安全，减少潜在风险。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/数据驱动智能诊断.png',
              title: '智能指挥 快速响应',
              description: '远程指挥中心实时监控和调度，快速响应现场问题，优化资源配置，提高工程管理效率和应急处理能力。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/数据驱动精准决策.png',
              title: '数据驱动 精准决策',
              description: '利用数据闭环系统进行数据分析和智能预测，提供精准决策支持，确保项目进度与质量，提升管理水平。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准检测保障安全.png',
              title: '全程监管 提升质量',
              description: '全流程数字化监管，从规划到竣工全程跟踪，确保每个环节的质量控制，推动基建项目的高质量完成。 ',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/全时值守韧性升级.png',
              title: '成本优化 资源高效',
              description: '通过自动化设备和智能管理系统，降低人力和运维成本，实现资源高效利用，提升经济效益和可持续发展。 ',
            },
          ]
          break;

        case 'industry_uav_safe':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '立体安防 全域管控',
              description: '系统立体化数据采集，实时传输现场数据，实现公共安全数据的精准化、可视化管理，推动公共安全立体化防控体系的数字化升级。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/无人强攻.png',
              title: '无人值守 昼夜运行',
              description: '固定式航空站无人值守、自动换电，可有效保障无人机24小时不间断执行巡防任务，有效弥补人工巡防时间与视觉盲区。	',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/极速响应.png',
              title: '快速机动 应急响应',
              description: '在突发事件中，无人机应急无人装备指挥车临时前指，集群管控1-4架无人机实时回传现场画面信息，为应急指挥中心提供第一手信息。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/成本优化.png',
              title: '安全可靠 降本增效',
              description: '系统可替代部分人力进行常态化巡检与监测，从多方面为公共安全保障工作创造显著经济效益，实现公共安全保障的经济高效化。',
            },
          ];

          break;
        case 'industry_uav_forest':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '巡检无盲区 安全无隐患',
              description: '搭载AI视觉系统与多向避障技术，可智能规划航线、高效扫描复杂地形，精准识别障碍。通过实时图传和三维建模实现无死角监控，显著提升巡检精度与效率。	',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/极速响应.png',
              title: '火情快响应 资源精勘测',
              description: '无人机搭载多光谱传感器，精准识别作物健康与污染分布，结合三维建模生成高精度地图，实现可视化分析，为农业、环保及灾害评估等提供科学决策支持。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/应急越险阻物资秒投送.png',
              title: '应急越险阻 物资秒投送',
              description: '	配备全地形底盘和智能避障系统，可快速抵达洪涝、塌方现场；实时回传灾情影像，空地协同实现分钟级救援响应。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/人机协同优生态守护久.png',
              title: '人机协同优 生态守护久',
              description: 'AI赋能无人装备，实现智能环境监测与治理；保障生态数据真实可溯，优化资源调配，助力可持续发展高效落地。',
            },
          ];
          break;
        case 'industry_uav_water':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高效实时水质分析.png',
              title: '高效实时 水质分析',
              description: '智能无人机搭载多参数传感器，实时监测水域数据，云端整合溯源预警，高效保障用水安全，替代人工提升应急响应。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准隐蔽工程检修.png',
              title: '精准隐蔽 工程检修',
              description: '智能水下机器人搭载摄像与机械臂，深入涵洞坝底探测隐患，高清成像结合三维建模，安全高效，降低运维成本，延长设施寿命。	',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/全流域动态地形测绘.png',
              title: '全流域动态 地形测绘',
              description: '智能无人船融合声呐与LiDAR技术，高效测绘河床地形、流速及淤积数据，显著提升防洪预测与疏浚精度，助力智慧水文科学决策。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/shui.png',
              title: '水域巡检 无人机群',
              description: '无人机群组网协同巡查，AI融合热成像技术，全天候监测非法采砂排污，自动取证定位。结合雷达构建"空天地"智能监测网，执法高效无盲区，共护水域生态安全。',
            },
          ];
          break;
        case 'industry_uav_delivery':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准配送.png',
              title: '精准配送',
              description: '无人装备（无人机/车）依托智能路径规划与精确避障，在城区/园区实现厘米级精准投递，突破交通限制，高效配送快递、医疗物资与应急补给，大幅节省人力与时间成本。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '快速响应',
              description: '无人装备以分钟级响应完成精准投送，突破断路、封锁等极端条件，打通空-地快速通道，高效投送关键物资，为救援或战场抢占决胜先机。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/降本增效.png',
              title: '降本增效',
              description: '相比传统运输，无人装备凭借智能调度与全天候作业，显著降低运输成本，高效完成工业零配件、仓储物资等多频次小批量配送，优化资源流转效率。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/灵活适应.png',
              title: '灵活适应',
              description: '从山地丛林到狭窄巷弄，无人装备凭借轻巧构型与多模态机动（垂直起降/履带越障），突破道路机场限制，高效驰援灾区、战区等复杂场景，填补传统运输空白。',
            },
          ];
          break;

        case 'industry_guan_wang':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高效全面覆盖.png',
              title: '高效全面覆盖',
              description: '无人机可快速巡查高空、狭窄管道等人工难以触及的区域，结合自动航线规划，大幅提升巡检效率，实现复杂管网的全方位无死角覆盖，缩短巡检周期。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/精准隐患识别.png',
              title: '精准隐患识别',
              description: '搭载高精度传感器与AI算法，实时检测腐蚀、裂纹、泄漏等缺陷，识别准确率达99%以上，减少人工误判风险，提前预警潜在故障，保障管网安全运行。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/全天候持续作业.png',
              title: '全天候持续作业',
              description: '适应夜间、极端天气及危险环境，7×24小时不间断巡检，避免人工疲劳及高风险区域作业的安全隐患，显著降低运维人员事故率。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/人机协同优生态守护久.png',
              title: '智能数据整合',
              description: '自动生成结构化巡检报告，结合数字孪生与大数据分析，实现设备健康管理，辅助科学决策，优化维护成本，延长管网使用寿命。',
            },
          ];
          break;


        case 'industry_gong_lu':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/技术领航.png',
              title: '全局立体 态势感知',
              description: '构建公路立体化监测网络，实时获取路况、交通流量等信息，打破信息局限，为公路管理提供精准的态势感知，提升公路运行监控水平。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/高空视角突破局限.png',
              title: '高空视角 突破局限',
              description: '突破传统地面巡防局限，凭借无人机高空视角与灵活机动性，实现对公路全路段、全天候空中巡查，有效补充地面巡防不足。	',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/空地协同立体巡防.png',
              title: '空地协同 立体巡防',
              description: '通过空地协同作业模式，形成全方位立体巡防格局，实现对公路设施智能化监测，大幅提升公路及周边环境监测效率与精准度。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '昼夜巡航 安全保障',
              description: '系统无人值守，可进行日常巡检与夜间监测，降低人力成本投入。同时，减少资源浪费与设备损耗，提高应急处置效率。',
            },
          ];
          break;
        case 'industry_tie_lu':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/智能数据整合.png',
              title: '智能巡检 数字升级',
              description: '实时采集、分析铁路数据，实现数字化管理，提升运营效率与决策科学性，推动铁路向智能化转型，适应行业发展趋势。	',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/无人强攻.png',
              title: '无人自主 智能决策',
              description: '系统具备自主作业能力，无需人员干预，全天候作业，减少人力短缺问题，保障运营连续性。	',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '降低风险 安全保障',
              description: '无人装备代替人工进入危险区域，如接触网巡检、灾害现场勘查等，避免人员暴露于高风险环境，保障铁路工作人员生命安全。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '自主决策 高效运行',
              description: '	高效处理铁路巡检数据，智能排查隐患信息，为铁路维护、运营管理等提供精准依据，优化资源配置。',
            },
          ];
          break;
        case 'industry_di_tie':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/无人强攻.png',
              title: '无人保障 自主巡检',
              description: '无人装备依循地铁铁轨自主行驶，全程无人值守，自主开展巡检作业，时刻守护地铁线路安全，全方位增强地铁运营全方位保障能力。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/智能数据整合.png',
              title: '无人检测 智能分析',
              description: '系统高精度检测地铁接触网、隧道结构等关键部位，自动捕捉异常，精准定位故障，提升巡检效率与准确性，助力地铁维护工作前置化。	',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '高效运维 精准决策',
              description: '无人装备实时回传巡检数据至控制中心，运维团队据此合理调配资源，实现预防性维护，降低故障发生率，提升运维效率。	',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '安全保障 风险防控',
              description: '无人装备可代替人工深入地铁隧道内进行巡检作业，有效规避隧道内环境复杂、高湿度、粉尘污染等安全风险，降低安全事故发生率。',
            },
          ];
          break;
        case 'industry_hai_yang':
          this.values = [
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '高效精准巡检',
              description: '多光谱+声呐+激光雷达无人装备，AI智能分析驱动，高效覆盖船舶难达水域，全天候精准作业，显著提升海洋监测、搜救及溢油检测的时效性与精确度。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/智能数据整合.png',
              title: '精准隐患识别',
              description: '无人装备替代高危作业，执行航道巡查、深海管道检测等任务，减少船员伤亡；低能耗、易维护，节省人力、燃油及运维成本，创造长期经济收益。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/效率提升.png',
              title: '全天候持续作业',
              description: 'AI驱动的无人设备具备自主规划航线、避障和实时数据传输能力，可在复杂海洋环境中智能化运行，减少人为干预。',
            },
            {
              icon: 'https://hr2.chnsoft.com.cn/img/安全强化.png',
              title: '智能数据整合',
              description: '模块化无人装备灵活适配多种载荷，满足环保监测、测绘安防等多元需求，助力风电巡检、军事侦察及渔业管理，实现资源高效利用。',
            },
          ];
          break;





        default:

          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.value-proposition {
  padding: 20PX;
  //   background-color: #f9f9f9;
  border-radius: 8PX;
  text-align: center;
  // padding: 0PX 18.75%;
  background: #FBFBFB;
  padding-top: 80PX;
  padding-bottom: 80PX;

  .value-body {
    width: 1200px;
    margin: 0 auto;
  }

  .title {
    margin: 0PX 0PX 80PX;
    font-family: PingFang SC;
    font-size: 32PX;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    color: #1E242A;
  }

  h2 {
    font-size: 24PX;
  }

  .value-items {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20PX;
  }

  .value-item {
    flex: 1 1 calc(20% - 20PX);
    // background-color: #fff;
    border-radius: 8PX;
    padding: 50PX 20PX;
    /* 上下增加 padding */
    // box-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.1);
    text-align: center;

    border-radius: 8PX;
    background: linear-gradient(180deg, rgba(15, 107, 246, 0.04) 0%, rgba(15, 107, 246, 0) 100%);
    border: 2PX solid #FFFFFF;
    position: relative;

    .value-icon {
      width: calc(80 / 1920 * 100vw);
      height: calc(80 / 1920 * 100vw);
      margin-bottom: 10PX;
      position: absolute;
      top: calc(-40 / 1920 * 100vw);
      /* 上移图片高度的一半 */
      left: 50%;
      transform: translateX(-50%);
    }

    h3 {
      font-size: 16PX;
      margin-bottom: 10PX;
      color: #1E242A;
      font-weight: bold;
    }

    p {
      font-size: 14PX;
      color: #1E242A;
    }
  }
}
</style>
